import { gql } from "@urql/core";

export const UserProfileJobFunctionFragment = gql`
    fragment UserProfileJobFunctionFragment on GrowthUnifiedProfileResult {
        userProfile {
            jobFunction
        }
    }
`;
